import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './HeaderFooter.css';

export default function GlobalHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Inject fonts
    const fontLinks = [
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;1,9..144,400&display=swap' }
    ];

    const injectedLinks = [];

    fontLinks.forEach(linkData => {
      const selector = linkData.rel === 'preconnect' 
        ? `link[rel="preconnect"][href="${linkData.href}"]`
        : `link[rel="stylesheet"][href="${linkData.href}"]`;
      
      if (!document.head.querySelector(selector)) {
        const link = document.createElement('link');
        Object.entries(linkData).forEach(([key, value]) => {
          link[key] = value;
        });
        document.head.appendChild(link);
        injectedLinks.push(link);
      }
    });

    return () => {
      injectedLinks.forEach(link => {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, []);

  const handleCtaClick = () => navigate('/scan');

  return (
    <>
      <nav className="site-header-nav">
        <div className="nav-inner">
        {/* Logo */}
        <Link to="/" className="nav-logo" aria-label="AI Search Advisers Home" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
          <div style={{ width: '32px', height: '32px', background: 'linear-gradient(to bottom right, #FEAB3D, #e8960a)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#021426" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>
          </div>
          <div>AI Search <span style={{ color: '#FEAB3D' }}>Adviser</span></div>
        </Link>
        
        <div className="nav-links">
          <Link 
            to="/" 
            style={{ color: location.pathname === '/' ? '#FEAB3D' : '' }}
          >
            Home
          </Link>
          <Link 
            to="/learn-more" 
            style={{ color: location.pathname === '/learn-more' ? '#FEAB3D' : '' }}
          >
            Learn More
          </Link>
          <Link 
            to="/pricing" 
            style={{ color: location.pathname === '/pricing' ? '#FEAB3D' : '' }}
          >
            Pricing
          </Link>
          <Link 
            to="/blogs" 
            style={{ color: location.pathname.startsWith('/blog') ? '#FEAB3D' : '' }}
          >
            Blogs
          </Link>
        </div>
        <div className="nav-right">
          <button className="nav-cta" onClick={handleCtaClick}>Free Audit &rarr;</button>
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle Menu">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
              </div>
      </nav>

      {/* Mobile menu overlay - outside nav to avoid backdrop-filter stacking context */}
      <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
        <Link to="/learn-more" onClick={() => setMobileMenuOpen(false)}>Learn More</Link>
        <Link to="/pricing" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
        <Link to="/blogs" onClick={() => setMobileMenuOpen(false)}>Blogs</Link>
        <button 
          className="mobile-cta" 
          onClick={() => { 
            setMobileMenuOpen(false); 
            navigate('/auth'); 
          }}
        >
          Login &rarr;
        </button>
      </div>
    </>
  );
}
